import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", path: "/", testid: "nav-home" },
  { label: "How It Works", path: "/how-it-works", testid: "nav-how" },
  { label: "Register School", path: "/register", testid: "nav-register" },
  { label: "Submit Entry", path: "/submit", testid: "nav-submit" },
  { label: "Rules & Recognition", path: "/rules", testid: "nav-rules" },
  { label: "Contact", path: "/contact", testid: "nav-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-sprouts-border"
      data-testid="top-nav"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-4 py-3">
          {/* Brand */}
          <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="nav-brand">
            <span className="text-lg sm:text-xl font-black tracking-tight text-sprouts-text">
              Sprouts
              <span className="text-sprouts-primary"> Edu Tours</span>
            </span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((item) => {
              const active = location.pathname === item.path;
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  data-testid={item.testid}
                  className={`px-2.5 lg:px-3 py-2 rounded-full text-sm font-semibold transition-colors whitespace-nowrap ${
                    active
                      ? "bg-sprouts-primary text-white"
                      : "text-sprouts-text hover:bg-slate-100"
                  }`}
                >
                  {item.label}
                </NavLink>
              );
            })}
          </nav>

          {/* Partner badge + mobile menu */}
          <div className="flex items-center gap-2">
            {/* Desktop: labelled badge */}
            <div
              className="hidden md:flex items-center gap-2.5 pl-3 pr-2 py-1.5 rounded-full bg-white border border-sprouts-border shadow-soft shrink-0"
              data-testid="media-partner-badge"
            >
              <span className="text-[10px] font-extrabold tracking-[0.15em] uppercase text-sprouts-muted leading-none whitespace-nowrap">
                Media Partner
              </span>
              <img
                src="/brand/times-nie.png"
                alt="Times NIE — The Times of India"
                className="h-8 lg:h-9 w-auto object-contain"
              />
            </div>

            {/* Mobile: compact logo-only badge (no label, no border) */}
            <img
              src="/brand/times-nie.png"
              alt="Times NIE — The Times of India"
              data-testid="media-partner-badge-mobile"
              className="md:hidden h-7 w-auto object-contain shrink-0"
            />

            <button
              className="md:hidden p-2 rounded-md hover:bg-slate-100"
              onClick={() => setOpen((v) => !v)}
              data-testid="nav-menu-toggle"
              aria-label="Toggle menu"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {/* Mobile drawer */}
        {open && (
          <nav className="md:hidden pb-3 flex flex-col gap-1" data-testid="mobile-nav">
            {NAV.map((item) => {
              const active = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`m-${item.testid}`}
                  onClick={() => setOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-semibold ${
                    active ? "bg-sprouts-primary text-white" : "text-sprouts-text hover:bg-slate-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        )}
      </div>
    </header>
  );
}
